<ng-template #content>
  <div class="modal-body">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <img src="../../../assets/icon/close-modal.svg" class="close" aria-label="Close"
            (click)="modalRef.dismiss('Cross click')" />
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <span class="title" i18n="parameters-cost|@@costOnSeverity">Chiffrage forfaitaire sur Sévérité</span>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-5  center">
          <span class="column-title" i18n="parameters-cost|@@vehicleClass">
            Classe véhicule :
          </span>
        </div>
        <div class="col-5">
          <ng-select [items]="vehicle.classes" [bindLabel]="'value'" [bindValue]="'display'" [(ngModel)]="selectedClass"
            [ngModelOptions]="{standalone: true}" [virtualScroll]='true' [searchable]='true' notFoundText="---"
            [clearable]='false' placeholder='Classe...' i18n="parameters-cost|@@class"
            (change)="handlerChangeClassName($event)">
          </ng-select>
        </div>
      </div>


      <div class="classArray mt-2" *ngIf="selectedClassIndex >= 0 && cost[selectedClassIndex]">
        <div class="row m-1" *ngFor="let location of cost[selectedClassIndex].location" #parentLocation>

          <div class="col-12">

            <div class="table-option-toggle">
              <div class="conatainer">
                <div class="row justify-content-between m-0 center firstRow"
                  (click)="parentLocation.classList.toggle('active')" style="cursor: pointer;">
                  <div class="col-11">
                    <span class="titleRow">{{location.value | vehicleLocation}}</span>
                  </div>
                  <div class="col-1">
                    <img [ngClass]="{'turn': parentLocation.classList.contains('active')}"
                      src="../../../assets/icon/chevron.svg" alt="">
                  </div>
                </div>
                <div class="row m-0 center" [ngClass]="{'d-none': !parentLocation.classList.contains('active')}">
                  <div class="col-9 center">
                    <span class="p-2" i18n="parameters-cost|@@replacementValue">Valeur Remplacement : </span>
                  </div>
                  <div class="col-3 alignR">
                    <input type="number" placeholder="Non défini" [(ngModel)]="location.remplacementCost">
                  </div>
                </div>

                <div *ngIf="parentLocation.classList.contains('active')">
                  <div class="table-option-toggle m-3" *ngFor="let itemValue of location.price" #childLocation>
                    <div class="conatainer">
                      <div class="row m-0 center firstRow brown" style="cursor: pointer;"
                        (click)="childLocation.classList.toggle('active')">
                        <div class="col-11">
                          <span class="titleRow">{{itemValue?.typeDamage | vehicleDamage}}</span>
                        </div>
                        <div class="col-1">
                          <img [ngClass]="{'turn': childLocation.classList.contains('active')}"
                            src="../../../assets/icon/chevron.svg" alt="">
                        </div>
                      </div>

                      <div *ngIf="childLocation.classList.contains('active')">
                        <div class="row m-0 center" *ngFor="let itemPrice of itemValue.value">
                          <div class="col-9 center">
                            <span class="p-2"> {{itemPrice?.severity | vehicleSeverity}}</span>
                          </div>
                          <div class="col-3 alignR">
                            <input type="number" placeholder="Non défini" [(ngModel)]="itemPrice.cost">
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>

              </div>
            </div>

          </div>
        </div>
      </div>

    </div>

  </div>

  <div class="modal-footer ">
    <div class="alignC">
      <button type="button" class="btn btn-lg primary longSubmit" (click)="modalRef.close('Save click')"
        i18n="parameters-cost|@@validate">Valider</button>
    </div>
  </div>
</ng-template>

<div class="container">
  <div class="row head">
    <div class="col-12">
      <span class="title" i18n="parameters-cost|@@cost">Chiffrage</span>
    </div>
  </div>
  <div class="row report-form">
    <div class="col-6 center">
      <span class="column-title" i18n="parameters-cost|@@costOnSeverity">Chiffrage forfaitaire sur Sévérité</span>
    </div>
    <div class="col-6 alignR">
      <button type="button" class="btn btn-lg secondary" (click)="openModal()">
        <span class="text-span" i18n="parameters-cost|@@editCostOnSeverity">Modifier le Chiffrage forfaitaire sur
          Sévérité</span>
      </button>
    </div>
  </div>
  <div class="row mt-0 mb-5" *ngIf="report">
    <div class="col-12">
      <div class="table-option-toggle">
        <div class="conatainer">
          <div class="row m-0 center-toggle">
            <div class="col-9">
              <span class="column-title" i18n="table-options-toggle|@@option">Option</span>
            </div>
            <div class="col-3">
              <span class="column-title" i18n="table-options-toggle|@@active">Activé</span>
            </div>
          </div>
          <div class="row m-0">
            <div class="col-9 center-toggle">
              <span i18n="parameters-report|@@AutomaticallyCheckDamages">Selectionner l'ensemble des dommages par
                défaut</span>
            </div>
            <div class="col-3">
              <div class="parameters-toggle ">
              <app-generic-toggle  (change)="changeAutoCost()"  [value]="report.checkDamages" ></app-generic-toggle>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>

</div>


// WEBPACK FOOTER //
// ./src/app/element/parameters-cost/parameters-cost.component.html